export function initSidebarToggle() {
  const button = document.getElementById('header-toggle-button')
  if (!button) return

  button.classList.toggle('d-none', !document.body.classList.contains('home'))

  button.addEventListener('click', () => {
    const sidebar = document.getElementById('sidebar')
    if (!sidebar) return

    sidebar.classList.toggle('tucked')
    document.getElementById('overlay')?.classList.toggle('active')
    sidebar.dispatchEvent(new Event('sidebarToggled'))
  })
}
